@if (hasContextMenu && !isMemberField) {
  <div class="scan-option-container" [ngStyle]="{'visibility': 'visible'}">
    <button #ScanOptionsButton
      soho-button="icon"
      icon="barcode"
      id="{{buttonId}}"
      [attr.tabindex]="isInAccessibilityMode ? 0 : -1"
      [attr.aria-haspopup]="true"
      class="context-menu-button scan-options-button"
      soho-context-menu
      [lazyLoad]="true"
      [autoFocus]="true"
      [beforeOpen]="ajaxCallbackFunction"
      (selected)="contextMenuEventFunction($event)"
      (close)="focusToScanOptionsButton()"
      (click)="openScanOptions($event)"
      (keydown.arrowDown)="openScanOptions($event)"
      (keydown.space)="openScanOptions($event)"
      (focus)="handleFocus()"
      (blur)="handleBlur()">
      <span class="audible">{{scanOptionsLabel}}</span>
    </button>
    <div class="popupmenu-wrapper bottom" role="application">
      <ul class="popupmenu" >
      </ul>
    </div>
  </div>
}

@if (!hasContextMenu && !isMemberField) {
  <div class="scan-option-container" [ngStyle]="{'visibility': 'visible'}">
    <button #ScanOptionsButton
      soho-button="icon"
      icon="barcode"
      [attr.tabindex]="isInAccessibilityMode ? 0 : -1"
      [attr.aria-haspopup]="true"
      class="context-menu-button scan-options-button"
      (focus)="handleFocus()"
      (blur)="handleBlur()">
      <span class="audible">{{scanOptionsLabel}}</span>
    </button>
  </div>
}
